import React, { createRef } from 'react';
import { isPlatform, IonAlert, IonRange, IonPicker, IonSelectOption, IonSelect, IonLoading, IonActionSheet, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle, IonFooter } from '@ionic/react';
import '../styles/Flashcards.scss';
import { Swiper, Slide } from 'react-dynamic-swiper'
import 'react-dynamic-swiper/lib/styles.css'
import Storage from '../Storage';
import SQLStorage from '../SQLStorage';
import ReactCardFlip from 'react-card-flip';
import Utilities from '../Utilities';
import FlashcardEditModal from './FlashcardEditModal';
import Flashcard from './Flashcard';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

import store from '../state/store';
import { updatedSetsSet } from '../state/actions/UpdatedSets';

import AppleMusicImg from '../images/applemusic.png';
import ApplePodcastImg from '../images/podcast.png';
import AmazonMusicImg from '../images/amazonmusic.png';
import SpotifyImg from '../images/spotify.png';
import TidalImg from '../images/tidal.png';
import { createGesture, Gesture } from '@ionic/react';

import { repeat, flask, logIn, volumeHigh, shuffle, gitCompare, star, create, close, helpBuoy, checkmarkDone, playCircle, play, pause, arrowDown, chevronDown, resize, reader, receipt, closeCircle, informationCircleSharp, contractOutline, contrastOutline, closeOutline } from 'ionicons/icons'

const { Handle } = Slider;

class Flashcards extends React.Component {

    constructor(props) {
        super(props);
        this.swiperRef = createRef();
        this.timer = null;
        this.timerRestartChunk = null;
        this.justHandledFocus = false;
        this.reviewTimeout = null
        this.state = {
            cards: [],
            currentCard: 0,
            reviewMode: "auto",
            chunks: "off",
            currentChunk: 0,
            alreadyReviewed: [],
            openCardI: null,
            autoPlayDrawer: null,
            autoplayStopConfirm: null,

            autoplayEnabled: false,
            autoplayStep: null,
            pauseAfterPrevious: localStorage.getItem("pauseAfterPrevious") ? parseInt(localStorage.getItem("pauseAfterPrevious")) : 0,
            termPronouncationCount: localStorage.getItem("termPronouncationCount") ? parseInt(localStorage.getItem("termPronouncationCount")) : 1,
            pauseBeforeDefReveal: localStorage.getItem("pauseBeforeDefReveal") ? parseInt(localStorage.getItem("pauseBeforeDefReveal")) : 1,
            defPronouncationCount: localStorage.getItem("defPronouncationCount") ? parseInt(localStorage.getItem("defPronouncationCount")) : 1,
            pauseBeforeNextWord: localStorage.getItem("pauseBeforeNextWord") ? parseInt(localStorage.getItem("pauseBeforeNextWord")) : 2,
            wordRepeatCount: localStorage.getItem("wordRepeatCount") ? parseInt(localStorage.getItem("wordRepeatCount")) : 1,

            currentPronounceCount: 0,
            currentRepeatCount: 0,
            showPracticeEnd: false
        }
    }

    componentWillUnmount() {
        if (isPlatform("ios") || isPlatform("android")) {
            window.removeEventListener("focus", this.handleFocus);
            window.removeEventListener("blur", this.handleBlur);
        }
    }

    async componentDidMount() {
        if (isPlatform("ios") || isPlatform("android")) {
            window.addEventListener("focus", this.handleFocus);
            window.addEventListener("blur", this.handleBlur);
        }
        
        let gesture = createGesture({ el: document.getElementById('flashcards-ion-page'), threshold: 0, gestureName: 'my-gesture', gesturePriority: 40.5, onMove: ev => {} });
        gesture.enable(true);
    }

    hintAutoplay() {
        this.setState({
            autoplayStopConfirm: true
        })
    }

    handleFocus = () => {
        console.log("__ handleFocus() " + this.state.autoplayStep)
        if (this.justHandledFocus) {
            console.log("__ JUST HANDLED RETURN handleFocus() " + this.state.autoplayStep)
            return;
        }
        this.justHandledFocus = true;
        setTimeout(() => {
            this.justHandledFocus = false;
        }, 500);
        if (this.state.autoplayEnabled) {
            clearTimeout(this.timer);
            if (this.state.autoplayStep === 0 || this.state.autoplayStep === 1) {
                console.log("__ ======= 0/1 ===> pronounceWord()");
                this.pronounceWord();
            } else if (this.state.autoplayStep === 2) {
                console.log("__ ======= 2 ===> flip()");
                if (this.state.cards[this.state.currentCard].flipped) {
                    this.pronounceWord();
                } else {
                    this.flip(this.state.currentCard, false);   
                }
            } else if (this.state.autoplayStep === 3) {
                console.log("__ ======= 3 ===> pronounceWord()");
                this.pronounceWord();
            } else if (this.state.autoplayStep === 4) {
                console.log("__ ======= 4 ===> autoNext()");
                this.autoNext();
            }
        }
    }

    handleBlur = () => {
        console.log("__ handleBlur " + this.state.autoplayStep)
        if (this.state.autoplayEnabled) {
            clearTimeout(this.timer);
            Utilities.stopPronounce();
        }
    }

    async ionViewDidEnter() {
        this.load();
    }

    async ionViewWillEnter() {
        this.setState({ fullscreenLoading: true });
    }

    async load() {
        let lastPractice = await Storage.getO("lastPractice");
        let lastFontSize = await Storage.getO("lastFontSize");

        let cards = [];
        let studyset;
        let setsRedux;

        if (lastPractice && lastPractice.type === "flashcards") {

            let currentCard = 0;

            if (!lastPractice.cardIds || lastPractice.cardIds.length === 0) {

                console.log("@@@@ NO CARDS IN LAST PRACTICE, reload due = ==== REVIEW AFTER: " + Utilities.timestamp())

                if (lastPractice.uninited) {
                    cards = JSON.parse(localStorage.getItem("uninitedPractice"));
                } else if (lastPractice.content === "due") {
                    cards = await SQLStorage.getDueCards(Utilities.timestamp());
                    console.log("@@@@REVIEW THESE: ", cards)
                } else if (lastPractice.content === "new") {
                    cards = await SQLStorage.getNewCards();
                } else if (lastPractice.content === "mastered" || lastPractice.content === "learnt" || lastPractice.content === "studying") {
                    cards = await SQLStorage.getCardsByStregth(lastPractice.content === "mastered" ? 5 : lastPractice.content === "learnt" ? 3 : 1 );
                } else {
                    cards = await SQLStorage.getAllCardsFromStudyset(lastPractice.content === "custom" ? null : lastPractice.content, "lastReviewed", "ASC");
                    cards = Utilities.filterForPractice(cards, lastPractice.filters.filter(f => !f.startsWith("keywords:")), lastPractice.filters.find(f => f.startsWith("keywords:")) ? lastPractice.filters.find(f => f.startsWith("keywords:")).replace("keywords:", "") : null);
                    studyset = await SQLStorage.getStudyset(lastPractice.content === "custom" ? cards[0].setId : lastPractice.content);
                    if (!studyset) {
                        store.dispatch(updatedSetsSet(['null'])); await Storage.remove("lastPractice"); window.toast(window.ln.setNotFound, "error"); this.props.history.goBack(); this.setState({ fullscreenLoading: false }); return;
                    }
                }
    
                if (lastPractice.total !== lastPractice.chunk) {
                    cards = cards.slice(0 + lastPractice.chunkI * lastPractice.chunk, (0 + lastPractice.chunkI * lastPractice.chunk) + lastPractice.chunk)
                }

            } else {

                if (lastPractice.uninited) {
                    cards = JSON.parse(localStorage.getItem("uninitedPractice"));
                    currentCard = lastPractice.currentCard;
                } else {
                    cards = await SQLStorage.getCardsByIds(lastPractice.cardIds, true);
                    currentCard = lastPractice.currentCard;
                }

            }

            if (!studyset && !lastPractice.uninited) {
                setsRedux = store.getState().calendar.studysets;
                if (!setsRedux) {
                    setTimeout(function() { this.load() }.bind(this), 100);
                    return;
                }
            }

            if (cards.length < 1) {
                store.dispatch(updatedSetsSet(['null'])); await Storage.remove("lastPractice"); window.toast(window.ln.notEnoughCards, "error"); this.props.history.goBack(); this.setState({ fullscreenLoading: false }); return;
            }

            if (studyset) {
                for (let i = 0; i < cards.length; i++) {
                    if (lastPractice.content === "custom") {
                        studyset = store.getState().calendar.studysets[cards[i].setId];
                    }
                    cards[i].setTerm = studyset.term || "";
                    cards[i].setDefinition = studyset.definition || "";
                }
            } else if (!lastPractice.uninited) {
                for (let i = 0; i < cards.length; i++) {
                    cards[i].setTerm = (setsRedux[cards[i].setId] && setsRedux[cards[i].setId].term) ? setsRedux[cards[i].setId].term : ""
                    cards[i].setDefinition = (setsRedux[cards[i].setId] && setsRedux[cards[i].setId].definition) ? setsRedux[cards[i].setId].definition : ""
                }
            }

            let tags = lastPractice.uninited ? [] : (await SQLStorage.getTags());

            this.setState({
                details: studyset,
                cards: cards,
                tags: tags,
                currentCard: currentCard,
                fullscreenLoading: false,
                reviewMode: 'auto',
                fontSize: lastFontSize || '3',
                alreadyReviewed: [],
                practiceConfig: lastPractice,
                autoplayStoppedBecauseEnd: false
            }, async function() {
                Utilities.trackEvent("Flashcards", "Flashcards Practice Start", lastPractice.content, this.state.currentCard);
                this.swiperRef.current.swiper().slideTo(this.state.currentCard);
                this.indexChange();
                if (!lastPractice.cardIds || lastPractice.cardIds.length === 0) {
                    let practiceConfig = this.state.practiceConfig;
                    practiceConfig.cardIds = this.state.cards.map(item => item.id);
                    this.setState({ practiceConfig: practiceConfig }, () => { this.savePracticeConfig() })
                }
            })

        } else {

            this.props.history.push('/sets');

        }

    }

    savePracticeConfig = async () => {
        let lastPractice = await Storage.getO("lastPractice");
        if (lastPractice) {
            let practiceConfig = this.state.practiceConfig;
            practiceConfig.currentCard = this.state.currentCard;
            Storage.setO("lastPractice", practiceConfig);
        }
    }

    checkPronouncationAvailability() {

        // TO DO needs to make different for different due sets - i think done
        if (window.globalVars.availableLanguages && this.state.details) {
            if (window.globalVars.availableLanguages.indexOf(this.state.details.term) > -1) this.setState({ termPronouncation: true  })
            if (window.globalVars.availableLanguages.indexOf(this.state.details.definition) > -1) this.setState({ definitionPronouncation: true  })
        }

    }

    setFontSize(type) {
        Utilities.trackEvent("Flashcards", "Flashcards Set Font Size", null, type);
        Storage.setO("lastFontSize", type);
        this.setState({ fontSize: type })
    }

    setChunkSize(count) {
        Utilities.trackEvent("Flashcards", "Flashcards Set Chunk Size", null, count);
        this.setState({ 
            chunks: count,
            currentChunk: 0,
            currentCard: 0
        })
    }

    async setMastered() {

        let cards = this.state.cards;
        let currentCard = cards[this.state.currentCard];
        let oldStrength = currentCard.strength;

        if (oldStrength === 5) {
            return;
        }

        Utilities.trackEvent("Flashcard", "Flashcard Master", this.state.cards[this.state.currentCard].id + "|Flashcards");

        currentCard.strength = 5;
        currentCard.history.push("2_strength-" + oldStrength + "_" + Utilities.timestamp());
        currentCard.history.push("1_strength-" + 5 + "_" + Utilities.timestamp());
        cards[this.state.currentCard] = currentCard

        this.setState({ cards: cards })
        await SQLStorage.saveCard(currentCard);
        await window.dropbox.queueForUpload("card", currentCard.id + "-" + currentCard.setId);
    }

    async reviewCard(ignoreReviewed) {
        if (this.state.practiceConfig.uninited) {
            return;
        }

        Utilities.trackEvent("Flashcard", "Flashcard Review", this.state.cards[this.state.currentCard].id + "|Flashcards");

        let alreadyReviewed = this.state.alreadyReviewed || [];
        if (alreadyReviewed.indexOf(this.state.currentCard) === -1 || ignoreReviewed) {
            let reviewedCard = this.state.cards[this.state.currentCard];
            reviewedCard.history.push("11_f_" + Utilities.timestamp());
            await SQLStorage.saveCard(reviewedCard);
            alreadyReviewed.push(this.state.currentCard);
            this.setState({ alreadyReviewed: alreadyReviewed })
            this.state.cards[this.state.currentCard] = reviewedCard;
            await window.dropbox.queueForUpload("card", reviewedCard.id + "-" + reviewedCard.setId);
        }
    }

    indexChange(ignoreReviewed) {
        this.reviewCard(ignoreReviewed);
        this.savePracticeConfig();
    }

    async setSetAutoplayValue(field, value) {
        this.setState({
            [field]: value
        })
    }

    async stopAutoplay(reset) {
        Utilities.trackEvent("Flashcards", "Flashcards Autoplay Stop");
        console.log("__ stopAutoplay()")
        clearTimeout(this.timer);
        Utilities.stopPronounce();
        this.setState({
            autoplayEnabled: false,
            autoplayStep: reset ? 0 : this.state.autoplayStep
        })
    }

    async startAutoplay() {
        Utilities.trackEvent("Flashcards", "Flashcards Autoplay Start");
        clearTimeout(this.timer);

        localStorage.setItem("pauseAfterPrevious", this.state.pauseAfterPrevious);
        localStorage.setItem("termPronouncationCount", this.state.termPronouncationCount);
        localStorage.setItem("pauseBeforeDefReveal", this.state.pauseBeforeDefReveal);
        localStorage.setItem("defPronouncationCount", this.state.defPronouncationCount);
        localStorage.setItem("pauseBeforeNextWord", this.state.pauseBeforeNextWord);
        localStorage.setItem("wordRepeatCount", this.state.wordRepeatCount);

        this.setState({
            autoplayEnabled: true,
            autoPlayDrawer: null
        }, () => {
            this.autoNext(true);
        })
    }

    flip(i, backToSame) {
        Utilities.trackEvent("Flashcard", "Flashcard Flip");
        console.log("__ flip()")
        let cards = this.state.cards;
        console.log("__ FLIPPING " + cards[i].flipped + " -> " + (!cards[i].flipped))
        cards[i].flipped = !cards[i].flipped;
        if (cards[i-1] && cards[i-1].flipped) {
            cards[i-1].flipped = false;
        }
        if (cards[i+1] && cards[i+1].flipped) {
            cards[i+1].flipped = false;
        }
        this.setState({ cards: cards }, () => {
            if (this.state.autoplayEnabled) {
                this.timer = setTimeout(() => {
                    console.log("__ FLIPPING AND THEN PRN")
                    this.pronounceWord();
                }, backToSame ? this.alternativeSliderValue(this.state.pauseBeforeDefReveal, true) * 1000 : 1000)
            }
        })
    }

    async autoNext(justInited) {

        console.log("__ autonext()")

        if (!this.state.cards[this.state.currentCard+1]) {
            this.stopAutoplay();
            this.setState({ autoplayStoppedBecauseEnd: true })
            this.timerRestartChunk = setTimeout(() => {
                this.repeatThisChunk();
            }, 10000);
            this.swiperRef.current.swiper().slideTo(this.state.currentCard+1, 300);
            return;
        }

        if (justInited) {
            if (this.state.cards[this.state.currentCard].flipped) {
                let cards = this.state.cards;
                cards[this.state.currentCard].flipped = false;
                this.setState({ cards: cards });
            }
        } else {
            this.swiperRef.current.swiper().slideTo(this.state.currentCard+1, 300);
        }

        this.setState({
            currentCard: justInited ? this.state.currentCard : this.state.currentCard + 1,
            autoplayStep: 0
        }, () => {
            this.timer = setTimeout(async function() {
                this.setState({
                    currentPronounceCount: 0,
                    currentRepeatCount: 0
                }, () => {
                    this.pronounceWord();
                })
            }.bind(this), justInited ? 1 : this.alternativeSliderValue(this.state.pauseAfterPrevious, true) * 1000);
        })

    }

    async pronounceWord() {

        console.log("__ pronounceWord")

        let card = this.state.cards[this.state.currentCard];
        let pronounceAgain = false;

        this.setState({ pronouncing: true })

        if ( (card.setTerm) && (card.term) && (!card.flipped) ) {
            pronounceAgain = this.state.currentPronounceCount < this.state.termPronouncationCount || !this.state.autoplayEnabled
            if (pronounceAgain) {
                this.setState({
                    autoplayStep: 1
                })
                await Utilities.pronounceWord(card.term, card.setTerm);
            }
        } else if ( (card.setDefinition) && (card.definition) && (card.flipped) ) {
            pronounceAgain = this.state.currentPronounceCount < this.state.defPronouncationCount || !this.state.autoplayEnabled
            if (pronounceAgain) {
                this.setState({
                    autoplayStep: 3
                })
                await Utilities.pronounceWord(card.definition, card.setDefinition);
            }
        }

        this.setState({ pronouncing: false })

        console.log("__ FINISH PRONOUCNE")

        if (this.state.autoplayEnabled) {
            if (!pronounceAgain) {
                this.setState({
                    currentPronounceCount: 0
                }, () => {
                    if (this.state.cards[this.state.currentCard].flipped) {
                        this.setState({
                            autoplayStep: 4
                        })
                        console.log("__TIMER SET")
                        this.timer = setTimeout(() => {
                            console.log("__TIMER UP")
                            if (this.state.currentRepeatCount + 1 < this.state.wordRepeatCount) {
                                this.setState({
                                    currentRepeatCount: this.state.currentRepeatCount + 1
                                }, () => {
                                    this.flip(this.state.currentCard, true);
                                })
                            } else {
                                this.autoNext();
                            }
                        }, this.alternativeSliderValue(this.state.pauseBeforeNextWord, true)* 1000);
                    } else {
                        this.setState({
                            autoplayStep: 2
                        })
                        console.log("__TIMER SET")
                        this.timer = setTimeout(() => {
                            console.log("__TIMER UP")
                            this.flip(this.state.currentCard);
                        }, this.alternativeSliderValue(this.state.pauseBeforeDefReveal, true) * 1000);
                    }
                })
            } else if (pronounceAgain) {
                this.setState({
                    currentPronounceCount: this.state.currentPronounceCount + 1
                }, () => {
                    this.timer = setTimeout(() => {
                        this.pronounceWord();
                    }, 1000);
                })
            }
        }

    }

    alternativeSliderValue = (value, getInSeconds) => {
        let seconds = [1, 2, 5, 10, 30, 60, 120, 300, 600, 900];
        return getInSeconds ? seconds[value] : (seconds[value] > 59 ? (Math.ceil(seconds[value]/60) + " min") : (seconds[value] + " sec") )
    }

    loadNextChunk = async () => {
        Utilities.trackEvent("Flashcards", "Flashcards Load next Round");
        let restartAutoplay = this.state.autoplayStoppedBecauseEnd;
        let practiceConfig = this.state.practiceConfig;
        practiceConfig.cardIds = [];
        this.setState({ practiceConfig : practiceConfig }, async () => { 
            await this.savePracticeConfig();
            await this.load();
            if (restartAutoplay) {
                this.startAutoplay();
            }
        })
    }

    // TO DO probs should do something for logged out here
    repeatThisChunk = () => {
        Utilities.trackEvent("Flashcards", "Flashcards Repeat this Round");
        let restartAutoplay = this.state.autoplayStoppedBecauseEnd;
        this.setState({
            currentCard: 0,
            autoplayStoppedBecauseEnd: false
        })
        this.swiperRef.current.swiper().slideTo(0, 300);
        setTimeout(() => {
            if (restartAutoplay) {
                this.startAutoplay();
            }
        }, 500)
    }

    onHide = (i) => {
        Utilities.trackEvent("Flashcard", "Flashcards Hide from Round", this.state.cards[this.state.currentCard].id + "|Flashcards");
        console.log("__onHidee()");
        let cards = this.state.cards;
        cards.splice(i, 1);
        if (cards[i])
            cards[i].flipped = false;
        let practiceConfig = this.state.practiceConfig;
        practiceConfig.cardIds = cards.map(item => item.id);
        this.setState({ 
            cards: cards,
            practiceConfig: practiceConfig
        }, () => {
            this.savePracticeConfig();
            if (this.state.cards.length === 0) {
                this.stopAutoplay(true);
                this.load();
            } else if (this.state.autoplayEnabled) {
                this.stopAutoplay(true);
                setTimeout(() => {
                    this.startAutoplay();  
                }, 400);
            }
            if (this.state.cards.length !== 0) {
                this.indexChange(true);
            }
        })
    }

    endPractice = async (continueLater) => {

        if (this.state.practiceConfig.uninited && continueLater === undefined) {
            this.endPractice(false);
            return;
        }

        Utilities.trackEvent("Flashcards", "Flashcards Practice End", null, continueLater ? 1 : 0);

        if (continueLater === undefined) {
            this.setState({
                endPracticeConfirm: true
            })
        } else {
            clearInterval(this.timerRestartChunk);
            if (this.state.autoplayEnabled)
                this.stopAutoplay()
            window.removeEventListener("focus", this.handleFocus);
            window.removeEventListener("blur", this.handleBlur);
            if (!continueLater) {
                await Storage.remove("lastPractice");
                localStorage.setItem("justEndedPractice", "true");
            }
            store.dispatch(updatedSetsSet([...new Set(this.state.cards.map(c => c.setId))]))
            this.props.history.goBack();
        }
    }

    render() {

        const currentCard = this.state.currentCard ? this.state.cards[this.state.currentCard] : null;

        return (
            <IonPage data-page="flashcards" data-autoplay={this.state.autoplayEnabled} id="flashcards-ion-page" data-last-card={this.state.showPracticeEnd ? "true" : "false"}>
                <IonHeader>
                    <IonToolbar
                        style={{
                            '--background': window.dark ? "#181818" : "whitesmoke",
                        }}
                    >
                    </IonToolbar>
                </IonHeader>
                <IonContent style={{ '--overflow': 'hidden' }}>
                    <div className="activities-wrapper">
                        <div className="activities activities-compact">
                            <div data-activity="autoplay" onClick={() => {
                                if (this.state.autoplayEnabled) {
                                    this.stopAutoplay(); 
                                } else {
                                    this.setState({
                                        autoPlayDrawer: true
                                    }, () => {
                                        Utilities.onDrawerShow();
                                    })
                                }
                            }}>
                                <IonIcon mode="ios" icon={repeat} />
                                <div>
                                    <IonLabel>{window.ln.autoplay}</IonLabel>
                                    <IonLabel>{(this.state.autoplayEnabled ? window.ln.on : window.ln.off)}</IonLabel>
                                </div>
                            </div>
                            <div data-activity="pronounce" onClick={() => { this.setState({ fontSizeActionSheet: true }) }}>
                                <IonIcon mode="ios" icon={resize} />
                                <div>
                                    <IonLabel>{window.ln.printFont}</IonLabel>
                                    <IonLabel>{window.FONT_SIZES && window.FONT_SIZES[parseInt(this.state.fontSize)]}</IonLabel>
                                </div>
                            </div>
                            <div data-activity="close" onClick={() => { this.endPractice() }}>
                                <IonIcon mode="ios" icon={close} />
                                <div>
                                    <IonLabel>{window.ln.close}</IonLabel>
                                    <IonLabel>{window.ln.practice}</IonLabel>
                                </div>
                            </div>
                            { (this.state.autoplayEnabled) &&
                                <div 
                                    className="autoplay-progress"
                                    data-expanded={"true"}
                                >
                                    <div className="head">
                                        <div 
                                            className="step int" 
                                            onClick={() => {
                                                this.stopAutoplay();
                                                this.setState({
                                                    autoPlayDrawer: true
                                                })
                                            }}
                                        >
                                            <div className="intervals">
                                                <IonIcon icon={repeat}  />
                                                <p>{this.state.wordRepeatCount} {window.ln.repeat}</p>
                                            </div>
                                        </div>
                                        <div className="middle">
                                            {this.state.currentCard+1} / {this.state.cards.length}
                                        </div>
                                        <div 
                                            className="step stop" 
                                            onClick={() => {
                                                this.stopAutoplay();
                                            }}
                                        >
                                            <div className="intervals">
                                                <IonIcon icon={closeCircle} />
                                                <p>{window.ln.stop}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="prog"
                                        onClick={() => {
                                            this.stopAutoplay();
                                            this.setState({
                                                autoPlayDrawer: true
                                            })
                                        }}
                                    >
                                        <div className="step" data-active={this.state.autoplayStep === 0}>
                                            <div className="intervals">
                                                <IonIcon icon={pause} />
                                                <p>{window.ln.pause} {window.ln.for}</p>
                                                <p>{this.alternativeSliderValue(this.state.pauseAfterPrevious)}</p>
                                            </div>
                                        </div>
                                        <div className="step" data-active={this.state.autoplayStep === 1}>
                                            <div className="intervals">
                                                <IonIcon icon={volumeHigh} />
                                                <p>{window.ln.say} {window.ln.term}</p>
                                                <p>{this.state.termPronouncationCount} {window.ln.times}</p>
                                            </div>
                                        </div>
                                        <div className="step" data-active={this.state.autoplayStep === 2}>
                                            <div className="intervals">
                                                <IonIcon icon={pause} />
                                                <p>{window.ln.pause} {window.ln.for}</p>
                                                <p>{this.alternativeSliderValue(this.state.pauseBeforeDefReveal)}</p>
                                            </div>
                                        </div>
                                        <div className="step" data-active={this.state.autoplayStep === 3}>
                                            <div className="intervals">
                                                <IonIcon icon={volumeHigh} />
                                                <p>{window.ln.say} {window.ln.defShort}</p>
                                                <p>{this.state.defPronouncationCount} {window.ln.times}</p>
                                            </div>
                                        </div>
                                        <div className="step" data-active={this.state.autoplayStep === 4}>
                                            <div className="intervals">
                                                <IonIcon icon={pause} />
                                                <p>{window.ln.pause} {window.ln.for}</p>
                                                <p>{this.alternativeSliderValue(this.state.pauseBeforeNextWord)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div
                        className="swiper-wrapper-top"
                        style={{
                            height: 'calc(100% - 176px)'
                        }}
                    >
                        <Swiper
                            swiperOptions={{
                                slidesPerView: 'auto',
                                direction: 'vertical',
                                noSwipingClass: 'no-swipe',
                            }}
                            ref={this.swiperRef}
                            onTransitionEnd={(swiper) => {
                                this.setState({ showPracticeEnd: false, currentCard: this.swiperRef.current.swiper().activeIndex }, function() { this.indexChange() })
                            }}
                        >
                               {this.state.cards.map((slide, i) => {
                                   return (
                                       <Slide 
                                        className={ (!this.state.autoplayEnabled) ? "" : "no-swipe" } 
                                        data-i={i} 
                                        key={"flash-" + i} 
                                       >
                                           { ( (this.state.currentCard + 3 > i) && (this.state.currentCard - 3 < i) ) &&
                                               <ReactCardFlip 
                                                isFlipped={slide.flipped} 
                                                flipDirection="horizontal"
                                               >
                                                   <div className="flashcard ioncard">
                                                       <Flashcard
                                                            fontSize={this.state.fontSize}
                                                            onClick={() => { (!this.state.autoplayEnabled) ? this.setState({ openCardI: i }) : this.hintAutoplay(); }}
                                                            onFlip={() => { (!this.state.autoplayEnabled) ? this.flip(i) : this.hintAutoplay(); }}
                                                            swipeAttempt={() => { if (this.state.autoplayEnabled) { this.hintAutoplay() } }}
                                                            tags={this.state.tags}
                                                            flashcard={slide}
                                                            i={i}
                                                            totalI={this.state.cards.length}
                                                            definition={slide.setDefinition}
                                                            term={slide.setTerm}
                                                            definitionPronouncation={(window.globalVars.availableLanguages.indexOf(slide.setDefinition) > -1)}
                                                            termPronouncation={(window.globalVars.availableLanguages.indexOf(slide.setTerm) > -1)}
                                                            view="flashcard"
                                                            side="front"
                                                            reviewed={this.state.alreadyReviewed.indexOf(i) !== -1}
                                                            autoPlaying={this.state.autoplayEnabled}
                                                            onAutoplayPronounce={() => {
                                                                this.hintAutoplay();
                                                            }}
                                                        />
                                                   </div>
                                                  <div className="flashcard ioncard">
                                                        <Flashcard
                                                            fontSize={this.state.fontSize}
                                                            onClick={() => { (!this.state.autoplayEnabled) ? this.setState({ openCardI: i }) : this.hintAutoplay(); }}
                                                            onFlip={() => { (!this.state.autoplayEnabled) ? this.flip(i) : this.hintAutoplay(); }}
                                                            swipeAttempt={() => { if (this.state.autoplayEnabled) { this.hintAutoplay() } }}
                                                            tags={this.state.tags}
                                                            flashcard={slide}
                                                            i={i}
                                                            totalI={this.state.cards.length}
                                                            definition={slide.setDefinition}
                                                            term={slide.setTerm}
                                                            definitionPronouncation={(window.globalVars.availableLanguages.indexOf(slide.setDefinition) > -1)}
                                                            termPronouncation={(window.globalVars.availableLanguages.indexOf(slide.setTerm) > -1)}
                                                            view="flashcard"
                                                            side="back"
                                                            reviewed={this.state.alreadyReviewed.indexOf(i) !== -1}
                                                            autoPlaying={this.state.autoplayEnabled}
                                                            onAutoplayPronounce={() => {
                                                                this.hintAutoplay();
                                                            }}
                                                        />
                                                   </div>
                                               </ReactCardFlip>
                                           }
                                       </Slide>
                                   )
                               })}
                               <Slide 
                                    className="no- swipe"
                                    data-i={this.state.cards ? this.state.cards.length : 0}
                                    key={"flash-" + (this.state.cards ? this.state.cards.length : 0)}
                                >
                                    <ReactCardFlip isFlipped={false} flipDirection="horizontal">
                                        <div className="flashcard ioncard flashcard-end">
                                            <div className='practice-end-wrapper'>
                                                <div className='practice-end'>
                                                    <h2>{window.ln.practiceCompleted}</h2>
                                                    { this.state.practiceConfig &&
                                                        <button onClick={() => {
                                                            clearInterval(this.timerRestartChunk);
                                                            this.loadNextChunk();
                                                        }}>{(window.ln.loadNextXCards).replace("__", "" /*this.state.practiceConfig.chunk*/)}</button>
                                                    }
                                                    { this.state.practiceConfig &&
                                                        <button onClick={() => {
                                                            clearInterval(this.timerRestartChunk);
                                                            this.repeatThisChunk();
                                                        }}>
                                                            {(window.ln.repeatPractice).replace("__", "" /*this.state.practiceConfig.chunk*/)}
                                                            { (this.state.autoplayStoppedBecauseEnd) &&
                                                                <CountdownCircleTimer
                                                                    isPlaying={true}
                                                                    duration={10}
                                                                    colors={['#666']}
                                                                    size={36}
                                                                    strokeWidth={4}
                                                                    colorsTime={[10]}
                                                                    >
                                                                    {({ remainingTime }) => remainingTime}
                                                                </CountdownCircleTimer>
                                                            }
                                                        </button>
                                                    }
                                                    <button onClick={ async () => {
                                                        this.endPractice();
                                                    }} >
                                                        {window.ln.closePractice}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flashcard ioncard">

                                        </div>
                                    </ReactCardFlip>
                                </Slide>
                       </Swiper>
                    </div>
                    <div className="activities-wrapper">
                        <div className="quick-actions activities activities-compact activities-compact-wrap">
                            { (!this.state.autoplayEnabled) &&
                                <div 
                                    className="pronounce-btn" 
                                    data-flagged={this.state.pronouncing ? "true" : "false"} 
                                    onClick={(e) => {
                                        if (this.state.practiceConfig.uninited) {
                                            this.setState({ uninitedRestrictionAlert: true }); return;
                                        }
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.pronounceWord(true); 
                                    }}
                                >
                                    <IonIcon className="review-icon" icon={volumeHigh} />
                                    <div>
                                        <IonLabel>{window.ln.pronounce}</IonLabel>
                                    </div>
                                </div>
                            }
                            { (this.state.autoplayEnabled) &&
                                <div 
                                    className="stop-autoplay-btn" 
                                    data-flagged={"false"} 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.stopAutoplay(); 
                                    }}
                                >
                                    <IonIcon className="review-icon" icon={close} />
                                    <div>
                                        <IonLabel>{window.ln.stop + " " + window.ln.autoplay}</IonLabel>
                                    </div>
                                </div>
                            }
                            <div 
                                className="master-btn" 
                                data-flagged={ (this.state.cards && this.state.cards[this.state.currentCard]) ? (this.state.cards[this.state.currentCard].strength === 5 ? "true" : "false") : "false"} 
                                onClick={async (e) => {
                                    if (this.state.practiceConfig.uninited) {
                                        this.setState({ uninitedRestrictionAlert: true }); return;
                                    }
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (this.state.cards[this.state.currentCard].strength !== 5) {
                                        await this.setMastered(); 
                                        this.onHide(this.state.currentCard);
                                    }
                                }}
                            >
                                <IonIcon className="master-icon" icon={checkmarkDone} />
                                <div>
                                    <IonLabel>{(this.state.cards && this.state.cards[this.state.currentCard] && this.state.cards[this.state.currentCard].strength === 5) ? window.ln.mastered : window.ln.markMastered }</IonLabel>
                                </div>
                            </div>
                            <div 
                                className='remove-from-queue-btn'
                                onClick={(e) => {
                                    if (this.state.practiceConfig.uninited) {
                                        this.setState({ uninitedRestrictionAlert: true }); return;
                                    }
                                    e.preventDefault();
                                    e.stopPropagation();
                                    this.onHide(this.state.currentCard);
                                }}
                            >
                                <IonIcon className="remove-icon" icon={closeOutline} />
                                <div>
                                    <IonLabel>{window.ln.hideFromPractice}</IonLabel>
                                </div>
                            </div>
                        </div>
                    </div>
                </IonContent>

                <IonFooter>
                    <IonToolbar style={{ '--background': window.dark ? "#181818" : "whitesmoke", }}>
                   </IonToolbar>
               </IonFooter>

                <SwipeableDrawer
                    anchor="bottom"
                    open={this.state.autoplayEnabled && !localStorage.getItem("external-apps-hidden")}
                    transitionDuration={0}
                    className="type-selector external-apps-drawer"
                    onOpen={ () => {
                        Utilities.onDrawerShow();
                    } }
                    onClose={ () => { 
                        Utilities.onDrawerHide();
                        localStorage.setItem("external-apps-hidden", "true")
                        this.setState({ showExternalApps: false })
                        document.querySelectorAll('.external-apps-wrapper').forEach((elem) => {elem.style.display="none"});
                    } }
                >
                    <div data-keyboard-showing={this.state.keyboardShowing} ref={this.modalRef} className="swipeable-drawer-body" className="type-selector-modal" style={{ 
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        padding: 15,
                        background: "white",
                        borderRadius: '24px 24px 0 0'
                    }} >
                        <div className="drag-indicator"></div>
                        <h2 style={{ textAlign: "center", marginBottom: 12, fontSize: '1em', fontWeight: 700 }}>
                            {window.ln.listenInBreak}
                        </h2>
                        <div className="drag-close-indicator" onClick={() => {
                            Utilities.onDrawerHide();
                            localStorage.setItem("external-apps-hidden", "true")
                            this.setState({ showExternalApps: false })
                            document.querySelectorAll('.external-apps-wrapper').forEach((elem) => {elem.style.display="none"});
                        }}>
                            <IonIcon icon={closeCircle} />
                        </div>
                        <div className="external-apps-wrapper">
                            <div className='external-apps'>
                                <div className='img app'>
                                <img className="app-img" src={AppleMusicImg} onClick={(e) => {
                                        e.preventDefault()
                                        e.stopPropagation();
                                        window.open('https://music.apple.com/gb/album/part-of-me/716084282?i=716085475', '_system', 'location=no')
                                    }} />
                                </div>
                                <div className='img app'>
                                    <img className="app-img" src={ApplePodcastImg} onClick={() => {
                                        window.open('https://podcasts.apple.com/us/podcast/darknet-diaries/id1296350485', '_system', 'location=no')
                                    }} />
                                </div>
                                <div className='img app'>
                                    <img className="app-img" src={SpotifyImg} onClick={() => {
                                        window.open('https://open.spotify.com/track/1nZzRJbFvCEct3uzu04ZoL?si=1eeecbd35696495a', '_system', 'location=no')
                                    }} />
                                </div>
                                <div className='img app'>
                                    <img className="app-img" src={TidalImg} onClick={() => {
                                        window.open('https://tidal.com/browse/track/35355437', '_system', 'location=no')
                                    }} />
                                </div>
                                <div className='img app'>
                                    <img className="app-img"  src={AmazonMusicImg} onClick={() => {
                                        window.open('https://music.amazon.com/albums/B007JOM7C4', '_system', 'location=no')
                                    }} />
                                </div>
                            </div>
                            <button
                                className='default' 
                                onClick={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation();
                                    localStorage.setItem("external-apps-hidden", "true")
                                    this.setState({ showExternalApps: false })
                                    document.querySelectorAll('.external-apps-wrapper').forEach((elem) => {elem.style.display="none"});
                                }}
                                style={{
                                    margin: '15px 0 0 0',
                                    width: '100%'
                                }}
                            >
                                {window.ln.close}
                            </button>
                        </div>
                    </div>
                </SwipeableDrawer>




                <SwipeableDrawer
                    anchor="bottom"
                    open={this.state.autoPlayDrawer !== null}
                    key="flashcard-editor"
                    transitionDuration={0}
                    className="type-selector"
                    onOpen={ () => {
                        Utilities.onDrawerShow();
                    } }
                    onClose={ () => { 
                        Utilities.onDrawerHide();
                        this.setState({  autoPlayDrawer: null }) 
                    } }
                >
                    <div data-keyboard-showing={this.state.keyboardShowing} ref={this.modalRef} className="swipeable-drawer-body" className="type-selector-modal" style={{ 
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        padding: 15,
                        background: "white",
                        borderRadius: '24px 24px 0 0'
                    }} >
                        <div className="drag-indicator"></div>
                        <h2 style={{ textAlign: "center", marginBottom: 12, fontSize: '1em', fontWeight: 700 }}>
                            {window.ln.autoplayPreferences}
                        </h2>
                        <div className="drag-close-indicator" onClick={() => {
                            Utilities.onDrawerHide();
                            this.setState({  autoPlayDrawer: null }) 
                        }}>
                            <IonIcon icon={closeCircle} />
                        </div>
                        <div 
                            className="info-banner"
                            style={{
                                margin: '15px 0 0 0'
                            }}
                        >
                            <IonIcon icon={informationCircleSharp} />
                            <label>
                                {window.ln.keepScreenOnInfo}
                            </label>
                        </div>
                        <div className="autoplay-options">
                            <div className="line">
                                <div className="opts">
                                    <div className="opt">
                                        <div className="ico">
                                            <IonIcon icon={pause} />
                                        </div>
                                        <div className="side">
                                            <h3>{window.ln.autoPlay1}</h3>
                                            <Slider min={0} max={9} step={1} dots={true} 
                                                defaultValue={this.state.pauseAfterPrevious}    
                                                onChange={(val) => { this.setSetAutoplayValue("pauseAfterPrevious", val); }} handle={(props) => { return <div className="knob"><Handle value={props.value} {...props}>{this.alternativeSliderValue(props.value)}</Handle></div> }}
                                            />
                                        </div>
                                    </div>
                                    <div className="arrow">
                                        <IonIcon icon={chevronDown} />
                                    </div>
                                    <div className="opt">
                                        <div className="ico">
                                            <IonIcon icon={play} />
                                        </div>
                                        <div className="side">
                                            <h3>{window.ln.autoPlay2}</h3>
                                            <Slider min={0} max={5} step={1} dots={true} 
                                                defaultValue={this.state.termPronouncationCount}    
                                                onChange={(val) => { this.setSetAutoplayValue("termPronouncationCount", val); }} handle={(props) => { return <div className="knob"><Handle value={props.value} {...props}>{props.value}</Handle></div> }}
                                            />
                                        </div>
                                    </div>
                                    <div className="arrow">
                                        <IonIcon icon={chevronDown} />
                                    </div>
                                    <div className="opt">
                                        <div className="ico">
                                            <IonIcon icon={pause} />
                                        </div>
                                        <div className="side">
                                            <h3>{window.ln.autoPlay3}</h3>
                                            <Slider min={0} max={9} step={1} dots={true} 
                                                defaultValue={this.state.pauseBeforeDefReveal}    
                                                onChange={(val) => { this.setSetAutoplayValue("pauseBeforeDefReveal", val); }} handle={(props) => { return <div className="knob"><Handle value={props.value} {...props}>{this.alternativeSliderValue(props.value)}</Handle></div> }}
                                            />
                                        </div>
                                    </div>
                                    <div className="arrow">
                                        <IonIcon icon={chevronDown} />
                                    </div>
                                    <div className="opt">
                                        <div className="ico">
                                            <IonIcon icon={play} />
                                        </div>
                                        <div className="side">
                                            <h3>{window.ln.autoPlay4}</h3>
                                            <Slider min={0} max={5} step={1} dots={true} 
                                                defaultValue={this.state.defPronouncationCount}    
                                                onChange={(val) => { this.setSetAutoplayValue("defPronouncationCount", val); }} handle={(props) => { return <div className="knob"><Handle value={props.value} {...props}>{props.value}</Handle></div> }}
                                            />
                                        </div>
                                    </div>
                                    <div className="arrow">
                                        <IonIcon icon={chevronDown} />
                                    </div>
                                    <div className="opt">
                                        <div className="ico">
                                            <IonIcon icon={pause} />
                                        </div>
                                        <div className="side">
                                            <h3>{window.ln.autoPlay5}</h3>
                                            <Slider min={0} max={9} step={1} dots={true} 
                                                defaultValue={this.state.pauseBeforeNextWord}    
                                                onChange={(val) => { this.setSetAutoplayValue("pauseBeforeNextWord", val); }} handle={(props) => { return <div className="knob"><Handle value={props.value} {...props}>{this.alternativeSliderValue(props.value)}</Handle></div> }}
                                            />
                                        </div>
                                    </div>
                                    <div className="arrow">
                                        <IonIcon icon={chevronDown} />
                                    </div>
                                    <div className="opt">
                                        <div className="ico">
                                            <IonIcon icon={repeat} />
                                        </div>
                                        <div className="side">
                                            <h3>{window.ln.autoPlay6}</h3>
                                            <Slider min={1} max={5} step={1} dots={true} 
                                                defaultValue={this.state.wordRepeatCount}    
                                                onChange={(val) => { this.setSetAutoplayValue("wordRepeatCount", val); }} handle={(props) => { return <div className="knob"><Handle value={props.value} {...props}>{props.value}</Handle></div> }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button
                                onClick={() => {
                                    this.startAutoplay();
                                }}
                                className="main"
                            >
                                {window.ln.startAutoPlay}
                            </button>
                        </div>
                    </div>
                </SwipeableDrawer>
                <IonActionSheet
                    isOpen={this.state.fontSizeActionSheet}
                    header={window.ln.printFont}
                    onDidDismiss={() => { this.setState({ fontSizeActionSheet: false }) }}
                    buttons={[
                        {
                            text: window.ln.verySmall,
                            handler: () => { this.setFontSize("1") }
                        },
                        {
                            text: window.ln.small,
                            handler: () => { this.setFontSize("2") }
                        },
                        {
                            text: window.ln.normal,
                            handler: () => { this.setFontSize("3") }
                        },
                        {
                            text: window.ln.big,
                            handler: () => { this.setFontSize("4") }
                        },
                        {
                            text: window.ln.veryBig,
                            handler: () => { this.setFontSize("5") }
                        },
                    ]}
                />
                <IonActionSheet
                    isOpen={this.state.uninitedRestrictionAlert}
                    header={window.ln.uninitedRestriction}
                    onDidDismiss={() => { this.setState({ uninitedRestrictionAlert: false }) }}
                    buttons={[
                        {
                            text: window.ln.getStartedHere,
                            handler: () => {
                                let uninitedPracticeUrl = localStorage.getItem("uninitedPracticeUrl");
                                localStorage.removeItem("uninitedPracticeUrl");
                                localStorage.removeItem("uninitedPractice");
                                this.props.history.push(uninitedPracticeUrl + "action=autoadd");
                            }
                        },
                        {
                            text: window.ln.downloadFromAppStore,
                            handler: () => { window.open("https://itunes.apple.com/gb/app/id1496147001") }
                        },
                        {
                            text: window.ln.downloadFromGooglePlay,
                            handler: () => { window.open("https://play.google.com/store/apps/details?id=com.dominikgyecsek.simplecards") }
                        }
                    ]}
                />
                <IonActionSheet
                    isOpen={this.state.endPracticeConfirm}
                    header={window.ln.deletePractice + "?"}
                    onDidDismiss={() => { this.setState({ endPracticeConfirm: false }) }}
                    buttons={[
                        {
                            text: window.ln.continueLater,
                            handler: () => { this.endPractice(true) }
                        },
                        {
                            text: window.ln.deletePractice,
                            handler: () => { this.endPractice(false) }
                        }
                    ]}
                />
                <IonLoading
                    isOpen={this.state.fullscreenLoading}
                    message={window.ln.loading}
                    duration={2000}
                />
                { (this.state.openCardI !== null) &&
                    <FlashcardEditModal
                        onNewTag={(tag) => { this.setState({ tags: [...this.state.tags, tag] }) }}
                        open={this.state.cards[this.state.openCardI].id}
                        flashcard={this.state.cards[this.state.openCardI]}
                        defaultTerm={window.ln.term}
                        defaultDefinition={window.ln.def}
                        tags={this.state.tags}
                        updateTagReferences={(a, b) => { }}
                        onDelete={() => {
                            let cards = this.state.cards;
                            cards.splice(this.state.openCardI, 1)
                            this.setState({ cards: cards, openCardI: null, openCardNew: false })
                            // TO DO what if all delted?
                        }}
                        onClose={ async (changedCard) => {
                            if (changedCard) {
                                let cards = this.state.cards;
                                cards[this.state.openCardI] = JSON.parse(JSON.stringify(changedCard))
                                this.setState({ cards: cards })
                            }
                            this.setState({ openCardI: null, openCardNew: false })
                        }}
                    />
                }
                <IonAlert
                    isOpen={this.state.autoplayStopConfirm !== null}
                    onDidDismiss={() => { this.setState({ autoplayStopConfirm: null }) }}
                    header={window.ln.autoPlayOffConfirm}
                    buttons={[
                        {
                            text: window.ln.turnOff,
                            roel: 'delete',
                            handler: () => { this.stopAutoplay() }
                        },
                        {
                            text: window.ln.keepPn,
                            role: 'cancel',
                        }
                    ]}
                />
            </IonPage>
        );
    }

};


export default withIonLifeCycle(Flashcards);
